import React from 'react';
import { Color } from 'modules/styles/colors';

export const styles = {
  fill: 'none',
  stroke: Color.black,
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10
} as const;

export default {
  svg: (
    <g>
      <g>
        <path d="M21.1,2.4v19.2H2.9V2.4H21.1 M23.4,0.1H0.6v23.9h22.8V0.1L23.4,0.1z" />
      </g>
      <line {...styles} x1="1.8" y1="8" x2="21.6" y2="8" />
      <rect x="4.9" y="11" width="3.3" height="3.3" />
      <rect x="4.9" y="16.3" width="3.3" height="3.3" />
      <rect x="10.4" y="11" width="3.3" height="3.3" />
      <rect x="10.4" y="16.3" width="3.3" height="3.3" />
      <rect x="15.8" y="11" width="3.3" height="3.3" />
      <rect x="15.8" y="16.3" width="3.3" height="3.3" />
      <circle cx="18" cy="4.6" r="1.1" />
      <circle cx="6" cy="4.6" r="1.1" />
    </g>
  ),
  viewBox: '0 0 32 32'
};
